"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaConstructionCombineResponseToJSON = exports.RosettaConstructionCombineResponseFromJSONTyped = exports.RosettaConstructionCombineResponseFromJSON = void 0;
function RosettaConstructionCombineResponseFromJSON(json) {
    return RosettaConstructionCombineResponseFromJSONTyped(json, false);
}
exports.RosettaConstructionCombineResponseFromJSON = RosettaConstructionCombineResponseFromJSON;
function RosettaConstructionCombineResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'signed_transaction': json['signed_transaction'],
    };
}
exports.RosettaConstructionCombineResponseFromJSONTyped = RosettaConstructionCombineResponseFromJSONTyped;
function RosettaConstructionCombineResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'signed_transaction': value.signed_transaction,
    };
}
exports.RosettaConstructionCombineResponseToJSON = RosettaConstructionCombineResponseToJSON;
//# sourceMappingURL=RosettaConstructionCombineResponse.js.map